<template>
  <div class="row">
    <div class="col-xl-5 mb-4 mb-xl-0">
      <div class="card speaking-preview-card h-100">
        <div class="card-body">
          <div class="section-heading mb-4">Bài học viên</div>

          <div v-for="(item, index) in homeworkItems" :key="item.outcomes_id || index" class="preview-item">
            <div class="preview-item__header">
              <span class="badge badge-primary preview-type-badge">
                {{ item.typeAnswer === RECORD_VIDEO ? 'Record video' : 'Record audio' }}
              </span>
              <span class="preview-item__index">Bài {{ index + 1 }}</span>
            </div>

            <div class="preview-stack">
              <div class="preview-panel mb-3">
                <div class="preview-panel__title">Đề bài</div>
                <div class="preview-panel__body">
                  <p v-if="item.group_question && item.group_question.description" class="font-weight-bold mb-2">
                    {{ item.group_question.description }}
                  </p>
                  <p v-if="item.group_question && item.group_question.script" class="mb-3 preview-script">
                    {{ item.group_question.script }}
                  </p>

                  <el-image
                    v-if="item.group_question && item.group_question.image"
                    class="preview-image mb-3"
                    :src="item.group_question.image"
                    fit="contain"
                  ></el-image>

                  <div v-if="item.group_question && item.group_question.video" class="media-wrap mb-3">
                    <video class="media-player" controls preload="auto">
                      <source :src="item.group_question.video" type="video/mp4">
                    </video>
                  </div>

                  <div v-if="item.group_question && item.group_question.audio" class="media-wrap">
                    <audio class="w-100" controls preload="auto">
                      <source :src="item.group_question.audio" type="audio/ogg">
                      <source :src="item.group_question.audio" type="audio/mpeg">
                    </audio>
                  </div>
                </div>
              </div>

              <div class="preview-panel">
                <div class="preview-panel__title">Bài làm</div>
                <div class="preview-panel__body preview-answer-body d-flex align-items-center justify-content-center">
                  <div v-if="item.typeAnswer === RECORD_VIDEO" class="media-wrap w-100">
                    <video class="media-player" controls preload="auto">
                      <source :src="item.student_answer" type="video/mp4">
                    </video>
                  </div>

                  <div v-if="item.typeAnswer === RECORD_AUDIO" class="w-100">
                    <audio class="w-100" controls :key="index">
                      <source :src="item.student_answer" type="audio/ogg">
                      <source :src="item.student_answer" type="audio/mpeg">
                    </audio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-7">
      <div class="speaking-sidebar">
        <SpeakingAssessment
          :evaluation-status="speakingEvaluation.evaluationStatus"
          :not-meet-reason="speakingEvaluation.notMeetReason"
          :not-meet-description="speakingEvaluation.notMeetDescription"
          :force-validate="forceValidate"
          @update:speakingEvaluation="handleSpeakingEvaluationUpdate"
        />

        <div class="card total-card">
          <div class="card-body">
            <div class="section-heading mb-4">Chấm bài</div>

            <SkillOfSpeaking
              v-for="(item, index) in LIST_SKILL_AUDIO_VIDEO"
              :key="item.key || index"
              :current-homework="evaluations"
              :type-skill="item"
              :total-score="totalScore"
              :type-course="typeCourse"
              :evaluation-status="speakingEvaluation.evaluationStatus"
              :homework-data="homeworkItems"
              :force-validate="forceValidate"
            />

            <div class="total-score-box">
              <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
                <div class="mb-3 mb-md-0">
                  <div class="total-score-box__label">
                    Điểm toàn bài
                    <span v-if="speakingEvaluation.evaluationStatus === 'pass'" class="text-danger">*</span>
                  </div>
                  <div class="total-score-box__hint">Điểm trung bình của các tiêu chí speaking</div>
                </div>

                <el-rate
                  class="summary-rate"
                  size="large"
                  :max="totalScore"
                  :show-score="true"
                  :value="totalScoreValue"
                  :disabled="true"
                  allow-half
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RECORD_AUDIO, RECORD_VIDEO, LIST_SKILL_AUDIO_VIDEO } from '../constant'
import SpeakingAssessment from './SpeakingAssessment.vue'
import SkillOfSpeaking from './SkillOfSpeaking.vue'

export default {
  name: 'MakeRecordAndVideo',
  components: {
    SpeakingAssessment: SpeakingAssessment,
    SkillOfSpeaking: SkillOfSpeaking
  },
  props: {
    currentHomework: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeCourse: {
      type: Number,
      default: 0
    },
    forceValidate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      RECORD_AUDIO: RECORD_AUDIO,
      RECORD_VIDEO: RECORD_VIDEO,
      LIST_SKILL_AUDIO_VIDEO: LIST_SKILL_AUDIO_VIDEO
    }
  },
  computed: {
    homeworkItems() {
      return this.currentHomework && this.currentHomework.data ? this.currentHomework.data : []
    },
    speakingEvaluation() {
      if (!this.currentHomework.speakingEvaluation) {
        this.$set(this.currentHomework, 'speakingEvaluation', this.defaultSpeakingEvaluation())
      }
      return this.currentHomework.speakingEvaluation
    },
    evaluations() {
      if (!this.currentHomework.evaluations) {
        this.$set(this.currentHomework, 'evaluations', this.defaultEvaluations())
      }

      this.LIST_SKILL_AUDIO_VIDEO.forEach((skill) => {
        if (!this.currentHomework.evaluations[skill.key]) {
          this.$set(this.currentHomework.evaluations, skill.key, {
            score: null,
            comment: '',
            detailedComments: {}
          })
        }

        if (!this.currentHomework.evaluations[skill.key].detailedComments) {
          this.$set(this.currentHomework.evaluations[skill.key], 'detailedComments', {})
        }
      })

      return this.currentHomework.evaluations
    },
    totalScore() {
      const firstQuestion = this.homeworkItems[0]
      if (firstQuestion && firstQuestion.group_question && firstQuestion.group_question.score_max) {
        return Number(firstQuestion.group_question.score_max)
      }
      return 10
    },
    totalScoreValue() {
      if (this.speakingEvaluation.evaluationStatus !== 'pass') {
        return 0
      }

      const scores = this.LIST_SKILL_AUDIO_VIDEO
        .map((item) => {
          const skill = this.evaluations[item.key]
          return skill && skill.score !== null && skill.score !== undefined ? Number(skill.score) : null
        })
        .filter((score) => score !== null && !isNaN(score))

      if (!scores.length) {
        return 0
      }

      const average = scores.reduce((sum, score) => sum + score, 0) / scores.length
      return this.roundToHalf(average)
    }
  },
  created() {
    this.ensureSpeakingData()
  },
  watch: {
    totalScoreValue: {
      immediate: true,
      handler(value) {
        this.$set(this.currentHomework, 'totalScore', value)
      }
    }
  },
  methods: {
    defaultSpeakingEvaluation() {
      return {
        evaluationStatus: 'pass',
        notMeetReason: '',
        notMeetDescription: ''
      }
    },
    defaultEvaluations() {
      const evaluations = {}

      this.LIST_SKILL_AUDIO_VIDEO.forEach((skill) => {
        evaluations[skill.key] = {
          score: null,
          comment: '',
          detailedComments: {}
        }
      })

      return evaluations
    },
    ensureSpeakingData() {
      if (!this.currentHomework.speakingEvaluation) {
        this.$set(this.currentHomework, 'speakingEvaluation', this.defaultSpeakingEvaluation())
      }

      if (!this.currentHomework.evaluations) {
        this.$set(this.currentHomework, 'evaluations', this.defaultEvaluations())
      }

      this.LIST_SKILL_AUDIO_VIDEO.forEach((skill) => {
        if (!this.currentHomework.evaluations[skill.key]) {
          this.$set(this.currentHomework.evaluations, skill.key, {
            score: null,
            comment: '',
            detailedComments: {}
          })
        }

        if (!this.currentHomework.evaluations[skill.key].detailedComments) {
          this.$set(this.currentHomework.evaluations[skill.key], 'detailedComments', {})
        }
      })
    },
    handleSpeakingEvaluationUpdate(payload) {
      this.ensureSpeakingData()
      this.$set(this.currentHomework.speakingEvaluation, payload.type, payload.value)

      if (payload.type === 'evaluationStatus' && payload.value !== 'fail') {
        this.$set(this.currentHomework.speakingEvaluation, 'notMeetReason', '')
        this.$set(this.currentHomework.speakingEvaluation, 'notMeetDescription', '')
      }
    },
    roundToHalf(value) {
      return Math.round(value * 2) / 2
    }
  }
}
</script>

<style lang="scss" scoped>
.speaking-preview-card,
.total-card {
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem rgba(140, 152, 164, 0.08);
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #3f4254;
  letter-spacing: 0.04em;
}

.preview-item {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #eef0f8;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.preview-item:last-child {
  margin-bottom: 0;
}

.preview-stack {
  display: block;
}

.preview-item__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.preview-item__index {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #7e8299;
}

.preview-type-badge {
  padding: 0.45rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  background: #5867dd;
}

.preview-panel {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #fff;
}

.preview-panel__title {
  margin-bottom: 0.75rem;
  font-size: 1rem;
  font-weight: 700;
  color: #3f4254;
  text-transform: uppercase;
}

.preview-panel__body {
  font-size: 0.975rem;
  color: #3f4254;
  line-height: 1.7;
}

.preview-answer-body {
  min-height: 120px;
}

.preview-script {
  white-space: pre-line;
}

.preview-image {
  display: block;
  max-width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
}

.media-wrap {
  width: 100%;
}

.media-player {
  width: 100%;
  max-height: 260px;
  border-radius: 0.5rem;
  background: #000;
}

.total-score-box {
  padding: 1.25rem;
  margin-top: 0.5rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.total-score-box__label {
  font-size: 1.1rem;
  font-weight: 700;
  color: #181c32;
}

.total-score-box__hint {
  margin-top: 0.25rem;
  font-size: 0.9375rem;
  color: #7e8299;
}

.summary-rate::v-deep .el-rate {
  display: flex;
  align-items: center;
}

.summary-rate::v-deep .el-rate__text {
  margin-left: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  color: #3699ff;
}
</style>
